import { render, staticRenderFns } from "./AddCampaignToProductPopUp.vue?vue&type=template&id=4b29780d"
import script from "./AddCampaignToProductPopUp.vue?vue&type=script&lang=js"
export * from "./AddCampaignToProductPopUp.vue?vue&type=script&lang=js"
import style0 from "./AddCampaignToProductPopUp.vue?vue&type=style&index=0&id=4b29780d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports